import React, { useEffect } from "react";
import { LabelPadrao, InputPadrao, DatePickerPadrao, LoadingContainerPadrao, ModalPadrao } from "../../components/Base";
import TabelaPadrao from "../../components/TabelaPadrao";
import { Divider, Input, Tooltip, Tabs } from "antd";
import * as api from "./ContasFinApi";
import { useFetch } from "../../components/Hooks/Conexao";
import { connect } from "react-redux";
import { fetch } from "../../actions";
import { AppstoreOutlined } from '@ant-design/icons';
import { TiDocumentText } from "react-icons/ti";
import { InputNumero } from "../../components/InputNumero";
import toLocale from "../../Utils/ToLocaleString";
import culture from "../../Utils/Culture";
import dayjs from "dayjs";
import { BtnSair } from "../../components/Buttons";
const { TabPane } = Tabs;
function ContasDetalhe({ id, ...props }) {
  const [conta, listar, isLoading] = useFetch(() => api.getById(props.fetch, id));

  useEffect(() => {
    if (!!id)
      listar();
  }, [id]);

  if (!conta)
    return <></>;

  return <>
    <div>
      <LoadingContainerPadrao loading={isLoading}>
        <Tabs tabPosition="left" style={{ minHeight: 450 }}>
          <TabPane tab={<Tooltip title="Principal" placement="right"><AppstoreOutlined /></Tooltip>} key="1">
            <div {...props}>
              <div style={{ display: "flex", width: "100%" }}>
                <div style={{ width: "50%", marginRight: 10 }}>
                  <LabelPadrao noMargin>Empresa</LabelPadrao>
                  <InputPadrao value={conta.empresa} disabled />
                </div>
                <div style={{ width: "50%" }}>
                  <LabelPadrao noMargin>{conta.isPagar ? "fornecedor" : "cliente "}</LabelPadrao>
                  <InputPadrao value={conta.pessoa} disabled />
                </div>
              </div>
              <div style={{ display: "flex", width: "100%" }}>
                <div style={{ width: "50%", marginRight: 10 }}>
                  <LabelPadrao>Plano de contas</LabelPadrao>
                  <InputPadrao value={conta.planoContas} disabled />
                </div>
                <div style={{ width: "50%" }}>
                  <LabelPadrao>Número/Duplicata</LabelPadrao>
                  <InputPadrao value={conta.numero} disabled />
                </div>
              </div>
            </div>
            <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
              <div style={{ width: "33%", display: "flex", flexDirection: "column" }}>
                <LabelPadrao >Emissão</LabelPadrao>
                <DatePickerPadrao disabled value={dayjs(conta.dtEmissao)} />
              </div>
              <div style={{ width: "33%", display: "flex", flexDirection: "column", margin: "0 10px" }}>
                <LabelPadrao >Vencimento</LabelPadrao>
                <DatePickerPadrao disabled value={dayjs(conta.dtVencimento)} />
              </div>
              <div style={{ width: "33%", display: "flex", flexDirection: "column" }}>
                <LabelPadrao >Competência</LabelPadrao>
                <DatePickerPadrao disabled value={dayjs(conta.dtCompetencia)} />
              </div>
            </div>
            <Divider />
            <div style={{ marginBottom: 50 }}>
              {!!conta.dataPagamento ? <>
                <div style={{ display: "flex" }}>
                  <p><b>Valor:</b> R$ {culture.format(conta.valor)}</p>
                  <p style={{ margin: "0 10px" }}><b>Desconto (-):</b> R$ {culture.format(conta.desconto)}</p>
                  <p><b>Juros (+):</b> R$ {culture.format(conta.jurosMulta)}</p>
                </div>
                {!conta.isRenegociacao && <>
                  <LabelPadrao noMargin>Valor pago</LabelPadrao>
                  <TabelaPadrao columns={columnsDetPgto} data={conta.pagamentos} />
                </>}
              </> :
                <>
                  <LabelPadrao noMargin>Valor</LabelPadrao>
                  <InputNumero value={conta.valor} disabled style={{ width: "33%" }} />
                </>}
            </div>
          </TabPane>

          <TabPane tab={<Tooltip title="Observação" placement="right"> <TiDocumentText fontSize={18} style={{ marginRight: 10 }} /> </Tooltip>} key="3" >
            <LabelPadrao noMargin>Observação</LabelPadrao>
            <Input.TextArea disabled value={conta.obs} />
          </TabPane>
        </Tabs>
      </LoadingContainerPadrao>
    </div>
  </>;
}

function ContasModal({ id, onCancel, ...props }) {
  return <ModalPadrao footer={<BtnSair onClick={onCancel} />} visible={!!id} width={850} bodyStyle={{ paddingLeft: 10 }} title="Contas detalhe" onCancel={onCancel}>
    <ContasDetalhe onCancel={onCancel} id={id} {...props} />
  </ModalPadrao>;
}

export default connect(null, { fetch })(ContasModal);

const columnsDetPgto = [
  {
    Header: "Modalidade",
    accessor: "nome",
    Footer: " ",
  },
  {
    Header: "Troco",
    accessor: "troco",
    Cell: props => (props.row.original.tipo == "troco" && !!props.row.original.troco) ? <span>{props.row.original.troco && toLocale(props.row.original.troco)} <span style={{ opacity: 0.5, marginLeft: 10 }}>({toLocale(props.row.original.valor)})</span></span> : <span></span>,
  },
  {
    Header: "Valor total",
    accessor: "recebido",
    tipo: "rs",
    Somar: true,
  },
];